import { SET_SURVEY } from "./actions"

const INITIAL_STATE = {
  pendingSurveys: 0,
}

export default function surveyCountReducer(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case SET_SURVEY:
      return { ...state, pendingSurveys: action.surveyCount }
    default:
      return state
  }
}
